import { render, staticRenderFns } from "./accountDetailManageList.vue?vue&type=template&id=d4bc207e&scoped=true"
import script from "./accountDetailManageList.vue?vue&type=script&lang=js"
export * from "./accountDetailManageList.vue?vue&type=script&lang=js"
import style0 from "./accountDetailManageList.vue?vue&type=style&index=0&id=d4bc207e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4bc207e",
  null
  
)

export default component.exports